import Vue, { KeepAlive } from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect:"/home",
    component: HomeView,
    children:[
      {
        path: '/home',
        name: 'home',
        meta:{
          title:"首页",
          KeepAlive:true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/home.vue')
      },
      {
        path: '/sb',
        name: 'sb',
        meta:{
          title:"设备类产品",
          KeepAlive:true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/sb.vue')
      },
      {
        path: '/hc',
        name: 'hc',
        meta:{
          title:"耗材类产品",
          KeepAlive:true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/hc.vue')
      },
      {
        path: '/user',
        name: 'user',
        meta:{
          title:"关于我们",
          KeepAlive:true
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/user.vue')
      },
    ]
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   redirect:"/about/index"
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
